import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../../utils";
export const DialogShellSection = /*#__PURE__*/ React.forwardRef(function DialogShellSection({ title, hint, action, className, children, ...props }, ref) {
    return /*#__PURE__*/ _jsxs("section", {
        ref: ref,
        className: cn("flex flex-col gap-3", className),
        ...props,
        children: [
            (title || action) && /*#__PURE__*/ _jsxs("div", {
                className: "flex items-baseline gap-2.5",
                children: [
                    title && /*#__PURE__*/ _jsx("div", {
                        className: "text-[10.5px] font-bold uppercase tracking-[0.10em] text-muted-foreground",
                        children: title
                    }),
                    hint && /*#__PURE__*/ _jsx("div", {
                        className: "flex-1 text-[11.5px] text-fg-subtle",
                        children: hint
                    }),
                    action && /*#__PURE__*/ _jsx("div", {
                        className: "ml-auto",
                        children: action
                    })
                ]
            }),
            children
        ]
    });
});

//# sourceMappingURL=DialogShellSection.js.map